import { render, staticRenderFns } from "./communicationForm.vue?vue&type=template&id=6ffecc8a&scoped=true"
import script from "./communicationForm.vue?vue&type=script&lang=js"
export * from "./communicationForm.vue?vue&type=script&lang=js"
import style0 from "./communicationForm.vue?vue&type=style&index=0&id=6ffecc8a&prod&lang=scss"
import style1 from "./communicationForm.vue?vue&type=style&index=1&id=6ffecc8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffecc8a",
  null
  
)

export default component.exports